<script>

    import { onMount, untrack } from 'svelte';
    import { _ } from 'svelte-i18n';

    let { value = $bindable(''), onSubmit } = $props();

    let inputElement;
    let inputValue = $state('');
    let statusMessage = $state('');


    /* Focus input on mount */

    onMount(() => {
        if (inputElement) {
            inputElement.focus();
        }
    });


    /* Watch for changes to inputValue and update value accordingly */

    $effect(() => {
        // Filter to only numbers
        const filtered = inputValue.replace(/[^0-9]/g, '');
        if (filtered !== inputValue) {
            inputValue = filtered;
        }

        // Always update value with current input (even if incomplete)
        value = filtered;

        // Auto-submit when code is complete (4 digits)
        if (filtered.length === 4 && onSubmit) {
            statusMessage = untrack(() => $_('verifying'));
            // Small delay to allow visual feedback
            setTimeout(() => {
                onSubmit();
            }, 100);
        }
    });


    /* Watch for external changes to value - when parent clears it, clear the input */
    
    $effect(() => {
        if (value !== '') {
            return;
        }
         
        if (inputValue === '') {
            return;                
        }

        inputValue = '';

        if (inputElement) {
            inputElement.focus();
        }
    });


    /* Handle form submission */

    function handleSubmit(e) {
        e.preventDefault();

        if (onSubmit) {
            onSubmit();
        }
    }

</script>

<form onsubmit={handleSubmit}>
    <div>
        <input
            bind:this={inputElement}
            type="text"
            inputmode="numeric"
            autocomplete="one-time-code"
            name="code"
            aria-label={$_('verification_code')}
            bind:value={inputValue}
            maxlength="4"
        >
    </div>
    <span class="sr-only" role="status">{statusMessage}</span>
</form>

<style>

    input {
        --border-color: color-mix(in srgb, var(--text-color) 10%, var(--background-color));
        --outline-color: color-mix(in srgb, var(--accent-background) 20%, transparent);

        font-size: 2rem;
        font-weight: 500;
        width: 4ch;
        padding: 0.2em 0.4em;

        border: 1px solid var(--border-color);
        border-radius: 5px;

        color: var(--text-color);
        background: var(--background-color);
    }

    input:focus {
        --border-color: var(--accent-background);
        --outline-color: color-mix(in srgb, var(--accent-background) 35%, transparent);

        outline: 4px solid var(--outline-color);
        outline-offset: 0;
    }

</style>